import React, {lazy} from 'react';
import {ROUTE_DELETE_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const DeleteReport = lazy(() =>
  import('../../../screens/DeleteReport')
    .then(module => ({default: module.DeleteReport})));

const DeleteReportNavigation = [
  {
    path: ROUTE_DELETE_REPORT,
    loader: authLoader,
    element: (
      <DeleteReport />
    ),
  },
];

export default DeleteReportNavigation;
